import React from 'react';
import { useTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import { setVisible } from '../../../../Reducers/Ui/Actions';
import { useDispatch } from 'react-redux';

import loadIcon from './icons/load.svg';

const LoadButton = withStyles({
  root: {
    display: 'flex',
    cursor: 'pointer',
    flexDirection: 'row',
    alignItems: 'center',
    margin: '0 8px',
  },
  icon: {
    width: 32,
  },
  label: {
    fontSize: '0.9em',
  },
})(({ classes }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const onLoad = () => {
    dispatch(setVisible('loadConfiguration', true));
  };
  return (
    <div className={classes.root} onClick={onLoad} title={t('loadConfiguration.title')}>
      <img src={loadIcon} className={classes.icon} />
    </div>
  );
});

export default LoadButton;
